import {
    GET_NOMINATIF,
    GET_LAPORAN_KEPANGKATAN,
    GET_NAIK_GAJI_BERKALA,
    GET_DIKLAT_PERJENJANGAN,
    GET_SUMPAH_PEGAWAI,
    GET_PRAJABATAN,
    GET_SLKS,
    GET_PENDIDIKAN_JURUSAN,
    GET_REKAPITULASI_PEGAWAI,
    GET_LIST_TIPE_REKAP,
    RESET_REKAPITULASI_PEGAWAI,
    GET_LAPORAN_JUMLAH_JABATAN_UNIT,
    GET_LIST_PEGAWAI_LAPORAN_JUMLAH_JABATAN_UNIT,
    GET_LIST_LAPORAN_REKAPITULASI_PENGHARGAAN_ASN,
} from 'shared/constants/ActionTypes';

const defaultData = {
    result: []
}

const INIT_STATE = {
    rekapitulasi: {
        type: [],
        list: {
            result: null,
        },
    },
    nominatif: { ...defaultData },
    laporanKepangkatan: { ...defaultData },
    naikGajiBerkala: { ...defaultData },
    diklatPerjenjangan: { ...defaultData },
    sumpahPegawai: { ...defaultData },
    prajabatan: { ...defaultData },
    slks: { ...defaultData },
    pendidikanJurusan: { ...defaultData },
    jumlahJabatanUnit: {
        result: null,
    },
    pegawaiByJabatan: {
        results: [],
    },
    rekapitulasiPenghargaan: {
        list: {
            result: {}
        }
    }
}

const laporanReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_NOMINATIF: {
            return {
                ...state,
                nominatif: action.payload
            }
        }
        case GET_LAPORAN_KEPANGKATAN: {
            return {
                ...state,
                laporanKepangkatan: action.payload
            }
        }
        case GET_NAIK_GAJI_BERKALA: {
            return {
                ...state,
                naikGajiBerkala: action.payload
            }
        }
        case GET_DIKLAT_PERJENJANGAN: {
            return {
                ...state,
                diklatPerjenjangan: action.payload
            }
        }
        case GET_SUMPAH_PEGAWAI: {
            return {
                ...state,
                sumpahPegawai: action.payload
            }
        }
        case GET_PRAJABATAN: {
            return {
                ...state,
                prajabatan: action.payload
            }
        }
        case GET_SLKS: {
            return {
                ...state,
                slks: action.payload
            }
        }
        case GET_PENDIDIKAN_JURUSAN: {
            return {
                ...state,
                pendidikanJurusan: action.payload
            }
        }
        case GET_REKAPITULASI_PEGAWAI: {
            return {
                ...state,
                rekapitulasi: {
                    ...state.rekapitulasi,
                    list: action.payload
                }
            }
        }
        case RESET_REKAPITULASI_PEGAWAI: {
            return {
                ...state,
                rekapitulasi: {
                    ...state.rekapitulasi,
                    list: {
                        result: null
                    }
                }
            }
        }
        case GET_LIST_TIPE_REKAP: {
            const list = action.payload.result
            const option = list.map((item) => ({ id: item.key, label: item.name }))
            return {
                ...state,
                rekapitulasi: {
                    ...state.rekapitulasi,
                    type: option
                }
            }
        }
        case GET_LAPORAN_JUMLAH_JABATAN_UNIT: {
            return {
                ...state,
                jumlahJabatanUnit: action.payload
            }
        }
        case GET_LIST_PEGAWAI_LAPORAN_JUMLAH_JABATAN_UNIT: {
            return {
                ...state,
                pegawaiByJabatan: action.payload
            }
        }
        case GET_LIST_LAPORAN_REKAPITULASI_PENGHARGAAN_ASN: {
            return {
                ...state,
                rekapitulasiPenghargaan: {
                    ...state.rekapitulasiPenghargaan,
                    list: action.payload
                }
            }
        }
        default:
            return state;
    }
};
export default laporanReducer;
